import * as getters from './Getters'
import * as actions from './Actions'
import * as mutations from './Mutaions'

//Statelerimiz
const state = () => ({
    countries : [],
    cities: [],
    towns: [],
    subscriptions: [],
    accountTypes: [],
    jobs: [],
    zoneTypes: [],
    brands: [],
    models: [],
    protocols: [],
    quickNotes: [],
    tasks: [],
    status: {},
    loading: false,
    signalGroups: [],
    signalTypes: [],
    systemModules: [],
    systemMenus: [],
    customFields: [],
    forms: [],
    formCustomFields: [],
    products:[],
    productsPageInfo:{},
    stockMovementTypes: [],
    faultSupportPieces: [],
    faultSupportResults: [],
    importantNumbers: [],
    vacations: [],
    vacation: {},
    vacationJobs: [],
    evaluationResults: [],
    eventCodes: [], 
    ticketStatus: [],
    eventCodesPageInfo: {},
    receivers: [],
    receiverDetail: {},
    receiverProtocols: [],
    formats: [],
    deviceTypes: [],
    constants: {}
})

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/Defination/index.js